import { PayloadAction } from "@reduxjs/toolkit";

import { NavigationState } from "../../types";

export const setHistory = (
  state: NavigationState,
  action: PayloadAction<NavigationState['history']['data']>
) => {
  state.history.data = action.payload;
};
